import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxif">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxif')}
            </Typography>
            <p><strong>{translate('fxif')}</strong> テストが真の場合は 1 を返し、テストが偽の場合は 2 を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>判定条件</td>
                                <td>Day() = 1</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}1<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>As result 1.</td>
                                <td>月の初め</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}2<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>結果その２</td>
                                <td>""</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. If( Day() = 1 , "Beginning of the month" , "" ) returns "" 今日が月の 1 日でない場合、またはその逆の場合。</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxcase">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxcase')}
            </Typography>
            <p><strong>{translate('fxcase')}</strong> 各条件を左から右の順序で評価し、真の条件が見つかった場合は、その条件の結果で指定された値を返します。どの条件にも当てはまらない場合は、デフォルトの結果が返されます。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')},{translate('results')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>条件と、条件が true の場合に返される結果です。</td>
                                <td>[[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]]</td>
                            </tr>
                            <tr>
                                <td>{translate('number')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>任意の値</td>
                                <td>"Late"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Case( [[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]] , "Late" ) 今日の日付が 10 以上小さい場合は「Early」を返し、今日の日付が 10 より大きく 20 以下の場合は「Mid」を返し、それ以外の場合は「Late」を返します。</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxisempty">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxisempty')}
            </Typography>
            <p><strong>{translate('fxisempty')}</strong> 空の場合、またはエラーが発生した場合は (true) を返し、それ以外の場合は (false) を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>任意の文字列</td>
                                <td>"text"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IsEmpty("テキスト") は false を返します</div>
                    <div>2. IsEmpty("") は true を返します</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);